import { UserRoleEnum } from '@core/enums/user_role_enum';

/** Shared role groups reused across per-device editor allow-lists (meter-role, phase-count, ...)
 * that each add their own extra roles on top of these two common groups. */
export const PARTNER_ADMIN_USER_ROLES: string[] = [UserRoleEnum.PartnerAdmin, UserRoleEnum.PartnerUser];

export const XEMEX_STAFF_ROLES: string[] = [
  UserRoleEnum.XemexAdmin,
  UserRoleEnum.XemexSupport,
  UserRoleEnum.XemexProduction,
];
